import React from "react";
import { Flex, Grid, Text } from "@chakra-ui/react";
import TestimonialCard from "../../../Components/testimonials/TestimonialCard";
import { testimonials } from "../../../Components/testimonials/testimonialsData";

function TestimonialSection() {
    return (
        <Flex
            mt="80px"                // Top margin increased
            mb="80px"
            direction="column"
            align="center"
            px={4}
        >
            <Text fontSize="36px" fontWeight="600" color="#fff" mb={10}>
                What Our Users Say
            </Text>
            <Grid
                templateColumns="repeat(auto-fit, minmax(280px, 1fr))"
                gap={6}
                width="100%"
                maxW="1200px"
            >
                {testimonials.map((t, index) => (
                    <TestimonialCard key={index} {...t} />
                ))}
            </Grid>
        </Flex>
    );
}

export default TestimonialSection;
